import { BookOpenBlankVariantIcon } from './BookOpenBlankVariantIcon';

/**
 * author: Google
 * id 08C8BAF9-6B91-458D-BE03-F6A7AABEA2AB
 * name book-open-blank-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-open-blank-variant.svg
 * tags
 */
export const ImportContactsIcon = BookOpenBlankVariantIcon;
export default ImportContactsIcon